import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { CopiedTextCard } from 'components/UserContentCards';
import { areCardsEqual } from 'utilities/sideNavUtils';

const arePropsEqual = (prevProps, nextProps) => {
  const contentItemPropToCompare = ['snippet'];

  return areCardsEqual(prevProps, nextProps, contentItemPropToCompare);
};

const CopiedContentListCard = memo(
  ({ contentItem, isSnippetLinkAvailable }) => {
    return (
      <CopiedTextCard
        key={contentItem.id}
        userContentItem={contentItem}
        isSnippetLinkAvailable={isSnippetLinkAvailable}
      />
    );
  },
  arePropsEqual,
);

CopiedContentListCard.propTypes = {
  contentItem: PropTypes.object.isRequired,
  isSnippetLinkAvailable: PropTypes.bool,
};

export default CopiedContentListCard;
